<template>
  <router-view />
</template>

<script>
export default {
  name: 'featured-banners-pages-container',
};
</script>
